export interface TransMsg {
  en: String;
  zhHant: String;
  zhHans: String;
}

function build(...text): TransMsg {
  return {
    en: text[0],
    zhHans: text[2],
    zhHant: text[1],
  };
}

const messages = {
  cart: {
    cartActivated: build("Cart activated", "購物車已啟動", "购物车已启动"),
    cartCleared: build("Cart cleared", "購物車已清除", "购物车已清除"),
    cartSetOnHold: build("Cart set on hold", "購物車已暫存", "购物车已暂存"),
    couponDiscount: build("Coupon Discount", "優惠券折扣", "优惠券折扣"),
    couponInvalid: build("Coupon code is invalid", "優惠券代碼無效", "优惠券代码无效"),
    couponTooLarge: build("Coupon Reduces Total Below Minimum", "優惠券使總額降至最低限度以下", "优惠券使总额降至最低限度以下"),
    enterCoupon: build("Enter Coupon Code", "輸入優惠券代碼", "输入优惠券代码"),
    enterGiftCard: build("Enter Gift Card Code", "輸入禮品卡代碼", "输入礼品卡代码"),
    giftCardDiscount: build("Gift Card Discount", "禮品卡折扣", "礼品卡折扣"),
    giftCardInvalid: build("Gift Card is invalid", "禮品卡無效", "礼品卡无效"),
    giftCardTooLarge: build(
      "Gift Card reduces total below minimum",
      "禮品卡使總額降至最低限度以下",
      "礼品卡使总额降至最低限度以下"
    ),
    itemPrice: build("Item Price", "商品價格", "商品价格"),
    membershipDiscount: build("Membership Discount", "会员折扣", "會員折扣"),
    noCouponOnOverride: build(
      "Cannot apply coupon after price override. Remove price override to use Coupon",
      "價格覆蓋後無法使用優惠券。刪除價格覆蓋以使用優惠券",
      "价格覆盖后无法使用优惠券。删除价格覆盖即可使用优惠券"
    ),
    noGiftCardOnOverride: build(
      "Cannot apply gift card after price override. Remove price override to use gift card",
      "價格覆蓋後無法使用禮品卡。刪除價格覆蓋以使用禮品卡",
      "价格覆盖后无法使用礼品卡。移除价格覆盖即可使用礼品卡"
    ),
    orderSummary: build("Order Summary", "訂單摘要", "訂單摘要"),
    pleaseAddProductToCart: build("Please add product to cart", "請添加產品到購物車", "请添加产品到购物车"),
    priceOverrideDiscount: build("Price Override Discount", "價格覆蓋折扣", "价格覆盖折扣"),
    productAddedToCart: build("Product added to cart", "產品已添加到購物車", "产品已添加到购物车"),
    productRemovedFromCart: build("Product removed from cart", "產品已從購物車中刪除", "产品已从购物车中删除"),
    recycleDeposit: build("Recycle Deposit", "回收按金", "回收押金"),
    removeDiscount: build("Remove Discount", "移除折扣", "移除折扣"),
    boxConversion: build("Box Conversion", "箱轉換", "箱转换"),
    selectCustomerFirst: build("Please select a customer first", "請先選擇客戶", "请先选择客户"),
    totalPrice: build("Total Price", "總價格", "总价格"),
    userCartDeleted: build("User cart deleted", "用戶購物車已刪除", "用户购物车已删除"),
  },
  cash: {
    amount: build("Amount", "金额", "金額"),
    backToSettlement: build("Back to Settlement", "返回結算", "返回結算"),
    cashDrawer: build("Cash Drawer", "現金抽屜", "現金抽屜"),
    cashRegister: build("Cash Register", "現金登記", "现金登记"),
    cashTransaction: build("Cash Transaction", "現金交易", "现金交易"),
    cashlogs: build("Cashlog", "现金记录", "現金記錄"),
    closedTime: build("Closed Time", "關閉時間", "關閉時間"),
    closeRegister: build("Close Register", "完成結算", "完成结算"),
    closingCash: build("Closing Cash", "結束現金", "結束現金"),
    closingSummary: build("Closing Summary", "結束摘要", "結束摘要"),
    description: build("Description", "描述", "描述"),
    enterClosingSummary: build("Enter Closing Summary: ", "輸入結算摘要：", "输入结算摘要："),
    endDate: build("End Date", "結束日期", "結束日期"),
    numberOfTransactions: build("Transactions", "交易次數", "交易次數"),
    openingCash: build("Opening Cash", "開始現金", "開始現金"),
    openStatus: build("open", "開啟", "开启"),
    refetchTransactions: build("Refetch Transactions", "刷新交易", "刷新交易"),
    register: build("Register", "登記", "登記"),
    registerCloseBy: build("Register Close By", "登記關閉者", "登記關閉者"),
    registerOpenBy: build("Register Open By", "登記開啟者", "登記開啟者"),
    staff: build("Staff", "員工", "員工"),
    startClosing: build("Start Closing", "開始結算", "开始结算"),
    startDate: build("Start Date", "開始日期", "開始日期"),
    time: build("Time", "時間", "時間"),
    totalCashReceived: build("Total Cash Received", "總現金收入", "总现金收入"),
    totalDeposit: build("Total Deposit", "總存款", "总存款"),
    totalPaymentReceived: build("Total Received", "總收款", "總收款"),
    totalRefund: build("Total Refund", "總退款", "總退款"),
    totalSales: build("Total Sales", "總銷售額", "總銷售額"),
    totalTransactions: build("Total Transactions", "總交易", "总交易"),
    totalWithdraw: build("Total Withdraw", "總提款", "总提款"),
    totalWithdrawal: build("Total Withdrawal", "總提款", "總提款"),
    type: build("Type", "類型", "類型"),
    withdrawal: build("Withdrawal", "提款", "提款"),
    selectTransactionType: build("Select a transaction type", "選擇交易類型", "选择交易类型"),
  },
  checkout: {
    addressR: build("Address Is Required"),
    areYouSure: build("Are you sure you?", "你確定這是你嗎？", "你確定這是你嗎？"),
    balance: build("Balance", "餘額", "餘額"),
    basic: build("Basic", "一般速遞", "一般速遞"),
    addOnDiscountProduct: build("Add On Discount Product", "加購折扣產品", "加购折扣产品"),
    cancel: build("Cancel", "取消", "取消"),
    changePaymentMethod: build("Change Payment Method", "更改付款方式", "更改付款方式"),
    checkout: build("Checkout", "結賬", "結賬"),
    collect: build("Collect", "結賬", "结账"),
    coupon: build("Coupon", "優惠券", "优惠券"),
    contactAddress: build("Address: ", "地址：", "地址："),
    contactNumber: build("Mobile Number:", "手機號碼 ：", "手機號碼 ："),
    continueLater: build("Continue Later", "稍後繼續", "稍後繼續"),
    country: build("Shipping Country / Region", "運送國家/地區", "運送國家/地區"),
    couponCode: build("Coupon Code", "優惠碼", "優惠碼"),
    customerEmail: build("Customer Email", "客戶電郵", "客戶電郵"),
    customerEyeInfo: build("Customer Eye Info", "客戶眼睛資料", "客戶眼睛資料"),
    customerInfo: build("Customer Info", "客戶資訊", "客户信息"),
    customerName: build("Customer Name", "客戶名稱", "客戶名稱"),
    delete: build("Delete", "刪除", "刪除"),
    deleteAddress: build("You are about to delete this address", "您即將刪除該地址", "你確定這是你嗎？"),
    deleteAddressBtn: build("Delete Address", "刪除地址", "刪除地址"),
    delivery: build("Delivery", "送貨", "送貨"),
    deliveryAddress: build("Shipping Address", "送貨地址", "送貨地址"),
    deliveryMethod: build("Delivery Method", "運送方法", "運送方法"),
    deposit: build("Deposit", "訂金", "訂金"),
    depositInfo: build("The balance needs to be paid next time", "餘額下次付款", "餘額下次付款"),
    depositPaid: build("Deposit Paid", "訂金已付", "訂金已付"),
    dollarAvailable: build("No Earned Dollars available", "沒有可用的積分", "沒有可用的積分"),
    earnPoint: build("Current Order Earning Dollar:", "此訂單取可獲積分：", "此訂單取可獲積分："),
    edit: build("Edit", "編輯", "編輯"),

    empty: build("Empty", "沒有付款方式", "沒有付款方式"),
    enterAmount: build("Enter Amount", "輸入金額", "輸入金額"),
    giftCard: build("Gift Card", "禮品卡", "礼品卡"),
    failure: build("Failure", "失敗", "失敗"),
    free: build("Free Shipping", "免運費", "免運費"),
    goToPay: build("Go To Pay", "前往付款", "前往付款"),
    hideAddress: build("Hide List", "隱藏列表", "隱藏列表"),
    itemTotal: build("Item Total", "項目總數", "項目總數"),
    localExpress: build("Local Express", "本地速遞", "本地速遞"),
    makeOrder: build("Make Order", "下訂單", "下訂單"),
    makeSureAction: build(
      "Please make sure as this action cannot be undone.",
      "請確保此操作無法撤消。",
      "請確保此操作無法撤消。"
    ),
    mobileNumberR: build("Mobile Number Is Required", "必需填寫手機號碼", "必需填寫手機號碼"),
    orderDetail: build("See Order Details", "查看訂單詳情", "查看訂單詳情"),
    orderDiscount: build("Order Discount", "訂單折扣", "訂單折扣"),
    orderNote: build("Order Note", "訂單備註", "訂單備註"),
    paid: build("Paid", "已付", "已付"),
    paragraph1: build(
      "Buy any of these products at a discount price when you buy ",
      "購買時可以折扣價購買以下任何產品 ",
      "購買時可以折扣價購買以下任何產品 "
    ),
    paragraph2: build("Customers who bought ", "購買 ", "購買"),
    paragraph3: build("also bought these items.", "的客戶也購買了這些商品 ", "的客戶也購買了這些商品 "),
    paragraph4: build("Your Order Has been Created Successfully!", "您的訂單已成功建立！", "您的訂單已成功建立！"),
    paragraph5: build("You have not completed payment", "您還沒有完成付款", "您還沒有完成付款"),
    paragraph6: build("You can continue your payment later in the ", "您可以稍後在", "您可以稍後在"),
    paragraph7: build("order details ", "訂單詳情", "訂單詳情"),
    paragraph8: build("page", "頁面繼續付款", "頁面繼續付款"),
    payOffline: build("Pay Offline", "線下支付", "線下支付"),
    payment: build("Payment", "付款", "付款"),
    paymentOptions: build("Payment Options", "付款方式", "付款方式"),
    paymentSuccessfully: build("Order Successful", "訂單成功", "订单成功"),
    pickUpAddress: build("Pick Up Address", "領取地址", "領取地址"),
    pickup: build("Pickup", "自取", "自取"),
    point: build("Points", "積分", "積分"),
    productDetails: build("Product Details", "產品詳情", "产品详情"),
    recalculateChange: build("Recalculate Change", "重新計算找零", "重新計算找零"),
    recipient: build("Recipient Name: ", "收件人姓名：", "收件人姓名："),
    recipientNameR: build("Recipient Name Is Required"),
    relatedProduct: build("Related Product", "相關產品", "相關產品"),
    returnHome: build("Return Home Page", "返回主頁", "返回主頁"),
    rewardPoints: build("Reward Point", "獎勵積分", "獎勵積分"),
    saveEyeInfoToDatabase: build("Save Eye Info To Database", "儲存眼睛資料", "儲存眼睛資料"),
    sfExpress: build("SF Express", "順豐速運", "順豐速運"),
    sfPickup: build("SF Pickup", "順豐自提", "順豐自提"),

    shippingExtra: build("Shipping Extra", "額外運費", "額外運費"),
    shippingFee: build("Shipping Fee", "運費", "運費"),
    showALLAddress: build("Show All previous Addresses", "顯示所有以前的地址", "顯示所有以前的地址"),

    submmitSuccessfully: build(
      "Thank you. Your order has been received and your payment is submitted. We will confirm the payment as soon as possible.",
      "謝謝。 您的訂單已收到，付款已提交。 我們將盡快確認付款。",
      "謝謝。 您的訂單已收到，付款已提交。 我們將盡快確認付款。"
    ),
    successful: build("Successful", "成功", "成功"),
    toBeDetermined: build("To Be Determined", "待定", "待定"),
    toastInfoOne: build(
      "Deposit cannot be more than or equal to amount to pay",
      "訂金不能大於或等於應付金額",
      "訂金不能大於或等於應付金額"
    ),
    toastInfoTwo: build(
      "Receiving amount cannot be more than the amount to pay",
      "收款金額不能大於應付金額",
      "收款金額不能大於應付金額"
    ),
    total: build("Total", "總數", "總數"),
    transactionCanceled: build("Transaction Canceled", "交易已取消", "交易已取消"),
    useEarnedPoints: build("Use Earned Dollar: ", "可使用 Officeman Dollar：", "可使用 Officeman Dollar："),
    useRewardPoints: build("Use Points", "使用積分", "使用积分"),
    totalRewardPoints: build("Total Reward Points", "總積分", "总积分"),
    maxRewardPointsLabel: build("Max", "上限", "上限"),
    /** Customer's total reward balance (account); distinct from max redeemable on this order */
    rewardPointsTotalBalance: build("Balance", "賬戶餘額", "账户余额"),
    useMaxRewardPoints: build("Use max", "全用", "用满"),
    clearRewardPoints: build("Clear", "清除", "清除"),
    rewardPointsGuestHint: build(
      "Reward points are not available for guest checkout. Search and select a member customer.",
      "訪客結帳不能使用積分，請搜尋並選擇會員客戶。",
      "访客结账不能使用积分，请搜索并选择会员客户。"
    ),
    rewardPointsNoBalance: build("No balance", "無餘額", "无余额"),
    usedPoints: build("Points Used:", "使用積分：", "使用積分："),
  },
  country: {
    country: build("Shipping Region", "運送地區", "運送地區"),
    pleaseSelect: build("Please Select Shipping Region", "請選擇運送地區", "請選擇運送地區"),
    search: build("Search", "搜尋", "搜尋"),
  },
  customer: {
    editCustomerInfo: build("Edit Customer Info", "編輯客戶資料", "编辑客戶资料"),
    searchNamePhone: build("Search name, Email, phone ...", "搜尋名字, 電郵, 電話 ...", "搜尋名字, 電郵, 電話 ..."),
    selectCustomer: build("Select A Customer", "請選擇客戶", "請選擇客戶"),
    addCustomer: build("Add Customer", "新增客戶", "新增客户"),
    customerAdded: build("Customer Added", "客戶已新增", "客戶已新增"),
    customerDetails: build("Customer Details", "客戶詳情", "客户详细信息"),
    editInformation: build("Edit Information", "編輯資料", "编辑资料"),
    email: build("Email", "電郵", "電郵"),
    eyeRecords: build("Eye Records", "眼睛記錄", "眼睛记录"),
    failedToAddCustomer: build("Failed To Add Customer", "新增客戶失敗", "新增客户失败"),
    findCustomer: build("Find Customer", "搜尋客戶", "搜尋客戶"),
    firstName: build("First Name", "名字", "名字"),
    lastName: build("Last Name", "姓氏", "姓氏"),
    mobileNumber: build("Mobile Number", "手機號碼", "手机号码"),
    noCustomersFound: build("No Customers Found", "未找到客戶", "未找到客户"),
    optometrist: build("Optometrist", "驗光師", "验光师"),
    orderDetails: build("Order Details", "訂單詳情", "订单详情"),
    personalInfo: build("Personal Information", "個人資料", "个人资料"),
    profile: build("Profile", "輪廓", "轮廓"),
    remarks: build("Remarks", "備註", "备註"),
    rewards: build("Rewards", "獎勵", "奖励"),
    info: build("Info", "資訊", "信息"),
    tailor: build("Tailor", "裁缝", "裁缝"),
    show: build("Show", "顯示", "显示"),
    hide: build("Hide", "隱藏", "隐藏"),
    gender: build("Gender", "性別", "性别"),
    age: build("Age", "年齡", "年龄"),
  },
  date: {
    customDate: build("Custom Date", "自訂日期", "自訂日期"),
    last30Days: build("Last 30 Days", "過去30天", "过去30天"),
    last365Days: build("Last 365 Days", "過去365天", "过去365天"),
    last7Days: build("Last 7 Days", "過去7天", "过去7天"),
    lastQuater: build("Last Quater", "上一季", "上一季"),
    thisMonth: build("This Month", "本月", "本月"),
    thisWeek: build("This Week", "本星期", "本星期"),
    today: build("Today", "今天", "今天"),
    ytd: build("YTD", "本年度", "本年度"),
  },
  delivery: {
    scanQRCode: build("Scan QR Code", "掃描 QR 碼", "扫描 QR 码"),
    enterTrackingId: build("Enter Tracking ID", "輸入追蹤編號", "输入追踪编号"),
    showList: build("Show List", "顯示列表", "显示列表"),
    hideList: build("Hide List", "隱藏列表", "隐藏列表"),
    readyForPickup: build("Ready for Pickup", "待取貨", "待取货"),
    trackingId: build("Tracking ID", "追蹤編號", "追踪编号"),
    deliveryAddress: build("Delivery Address", "送貨地址", "送货地址"),
    note: build("Note", "備註", "备注"),
    enterNote: build("Enter note", "輸入備註", "输入备注"),
    hasRecycle: build("Has Recycle", "有回收", "有回收"),
    frontDoorDropOff: build("Front Door Drop Off", "門口放置", "门口放置"),
    markAsDelivered: build("Mark as Delivered", "標記為已送達", "标记为已送达"),
    deliveryMarkedAsDelivered: build("Delivery marked as delivered", "送貨已標記為已送達", "送货已标记为已送达"),
    alreadyDelivered: build("Already Delivered", "已送達", "已送达"),
    deliveryNotFound: build("Delivery not found", "找不到送貨", "找不到送货"),
    noDeliveriesAvailable: build("No deliveries available", "沒有可用的送貨", "没有可用的送货"),
    processing: build("Processing...", "處理中...", "处理中..."),
    scheduled: build("Scheduled", "已排程", "已排程"),
    preparing: build("Preparing", "準備中", "准备中"),
    onDelivery: build("On Delivery", "運送中", "运送中"),
    canPickup: build("Can Pickup", "可取貨", "可取货"),
    delivered: build("Delivered", "已送達", "已送达"),
  },
  errors: {
    amtGreaterThanZero: build("Amount must be greater than zero", "金額必須大於零", "金额必须大于零"),
    contactAdmin: build(
      "Something went Wrong. Please contact Admin if unsure how to proceed",
      "出了點問題。如果不確定如何繼續，請聯絡管理員",
      "出了点问题。如果不确定如何继续，请联系管理员"
    ),
    insufficientBalance: build("Insufficient Balance", "餘額不足", "余额不足"),
    reasonRequired: build("Reason Is Required", "需要原因", "必填项"),
    selectTransactionType: build("Please select transaction type", "請選擇交易類型", "请选择交易类型"),
  },
  form: {
    add: build("Add", "新增", "新增"),
    cancel: build("Cancel", "取消", "取消"),
    create: build("Create", "新增", "新增"),
    delete: build("Delete", "刪除", "刪除"),
    discard: build("Discard", "放棄", "放棄"),
    edit: build("Edit", "修改", "修改"),
    emailR: build("Email Address Is Required", "電郵是必需的", "電郵是必需的"),
    firstNameR: build("First Name is Required", "名字為必填項", "名字是必填项"),
    form: build("Form", "表單", "表單"),
    lastNameR: build("Last Name is Required", "姓氏為必填項", "姓氏为必填项"),
    loading: build("Loading...", "載入中", "載入中"),
    mobileR: build("Mobile Number is required", "手機號碼為必填項", "手机号码为必填项"),
    save: build("Save", "儲存", "儲存"),
    saveInformation: build("Save Information", "儲存資料", "儲存資料"),
    select: build("Select", "選擇", "选择"),
    selected: build("Selected", "已選擇", "已选择"),
    submit: build("Submit", "提交", "提交"),
    confirm: build("Confirm", "確認", "確認"),
    test: build("Test", "測試", "测试"),
    update: build("Update", "更新", "更新"),
    updatedBy: build("Updated By", "更新者", "更新者"),
    collect: build("Collect", "收集", "收集"),
    reset: build("Reset", "重置", "重置"),
  },
  formLabels: {
    Typetoaddnotes: build("Type to add notes...", "輸入備註", "輸入備註"),
    ddMMYY: build("DD/MM/YY", "日/月/年", "日/月/年"),
    discount: build("Discount %", "折扣", "折扣"),
    discountPrice: build("Discount Price", "折扣價格", "折扣價格"),
    enterAddress: build("Enter Address", "輸入地址", "輸入地址"),
    enterDiscount: build("Enter Discount %", "輸入折扣 (%)", "輸入折扣 (%)"),
    enterDiscountPrice: build("Enter Discount ($)", "輸入折扣價格 ($)", "輸入折扣價格 ($)"),
    enterName: build("Enter Name", "輸入名稱", "輸入名稱"),
    enterNote: build("Enter Note", "輸入備註", "輸入備註"),
    enterReason: build("Enter Reason", "輸入原因", "输入原因"),
    enterOrderDiscountPercentage: build("Enter Order Discount (%)", "輸入訂單折扣 (%)", "輸入訂單折扣 (%)"),
    enterOrderDiscountPrice: build("Enter Order Discount ($)", "輸入訂單折扣價格 ($)", "輸入訂單折扣價格 ($)"),
    enterTel: build("Enter Phone Number", "輸入電話號碼", "輸入電話號碼"),
    orderDiscountPercentage: build("Order Discount (%)", "訂單折扣 (%)", "訂單折扣 (%)"),
    orderDiscountPrice: build("Order Discount ($)", "訂單折扣價格 ($)", "訂單折扣價格 ($)"),
    price: build("Price", "價格", "價格"),
    quantity: build("Quantity", "數量", "數量"),
    selectDateFrom: build("Date From", "選擇開始日期", "选择开始日期"),
    selectDateTo: build("Date To", "選擇結束日期", "选择结束日期"),
  },
  giftCard: {
    gift: build("Gift", "禮品", "礼品"),
    gifts: build("Gifts", "禮品", "礼品"),
    value: build("Value", "價值", "价值"),
    redeemAsReward: build("Redeem as reward", "兌換獎勵", "兑换奖励"),
  },
  language: {
    en: build("English", "英文", "英文"),
    zhHans: build("Chinese (Simplified)", "簡體中文", "簡體中文"),
    zhHant: build("Chinese (Traditional)", "繁體中文", "繁體中文"),
  },
  menu: {
    changeLang: build("Change Language", "更改語言", "更改语言"),
    colorTheme: build("Color Theme", "顏色主題", "颜色主题"),
    darkMode: build("Dark Mode", "黑暗模式", "黑暗模式"),
    lightMode: build("Light Mode", "日光模式", "日光模式"),
    login: build("Login", "登入", "登入"),
    logout: build("Logout", "登出", "登出"),
    searchNotFound: build("Search Not Found", "搜尋不到", "搜寻不到"),
  },
  notifications: {
    selectCustomerFirst: build("Please select a customer first", "請先選擇客戶", "請先選擇客戶"),
  },
  order: {
    NA: build("NA", "NA", "NA"),
    addNewAddresss: build("Add New +", "新增地址+", "新增地址+"),
    addNote: build("Add Note", "新增備註", "新增備註"),
    deleteNote: build("Delete Note", "刪除備註", "删除備註"),
    deleteNoteConfirm: build("Are you sure you want to delete this note?", "確定要刪除此備註嗎？", "确定要删除此備註嗎？"),
    deleteNoteError: build("Failed to delete note", "刪除備註失敗", "删除備註失敗"),
    hideFromCustomer: build("Hide From Customer", "隱藏給客戶", "隱藏給客戶"),
    hide: build("Hide", "隱藏", "隱藏"),
    addNoteToOrder: build("Add Note", "新增備註", "新增備註"),
    addPickupDate: build("Add Pickup Date", "輸入取貨日期", "輸入取貨日期"),
    allTime: build("All Time", "所有時間", "所有時間"),
    amount: build("Amount", "金額", "金额"),
    amountReceived: build("Amount Received", "已收金額", "已收金额"),
    arrived: build("Arrived", "已到達", "已到達"),
    awaitingPickup: build("Awaiting Pickup", "待取貨", "待取货"),
    cancelled: build("Cancelled", "取消", "取消"),
    changeickupDate: build("Change Pickup Date", "更改取貨日期", "更改取貨日期"),
    clearFilters: build("Clear Filters", "清除篩選", "清除篩選"),
    clickAnOrderToViewDetails: build("Click An Order To View Details", "點擊訂單查看詳情", "點擊訂單查看詳情"),
    completed: build("Completed", "已完成", "已完成"),
    customer: build("Customer", "客戶", "客戶"),
    customerInformation: build("Customer Information", "客戶資料", "客戶資料"),
    date: build("Date", "日期", "日期"),
    delivered: build("Delivered", "已收貨", "已收貨"),
    deposit: build("Deposit", "訂金", "訂金"),
    depositBalance: build("Deposit Balance", "訂金餘額", "訂金餘額"),
    depositPaid: build("Deposit Paid", "訂金已付", "訂金已付"),
    filterByDate: build("Filter By Date", "按日期篩選", "按日期篩選"),
    filterByStatus: build("Filter By Status", "按狀態篩選", "按狀態篩選"),
    fullPayment: build("Full Payment", "全額付款", "全额付款"),
    fullyPaid: build("Fully Paid", "已全數付款", "已全數付款"),
    grandTotal: build("Grand Total", "總金額", "总金额"),
    historyOrders: build("History Orders", "歷史訂單", "歷史订单"),
    hideOrderSummary: build("Hide summary", "隱藏摘要", "隐藏摘要"),
    itemsTotal: build("Items Total", "產品總額", "产品总额"),
    lessThanYesterday: build("Less than yesterday", "少於昨天", "少於昨天"),
    moreThanYesterday: build("More than yesterday", "多於昨天", "多於昨天"),
    noData: build("No Data", "沒有數據", "没有数据"),
    note: build("Note", "備註", "備註"),
    noOrderFound: build("No Order Found", "未找到訂單", "未找到订单"),
    noOrderYet: build("No Orders Yet", "尚未有訂單", "尚未有订单"),
    noPaymetyet: build("No Payment Yet", "尚未付款", "尚未付款"),
    noteDate: build("Note Date", "備註日期", "備註日期"),
    onlineOrder: build("Online Order", "線上訂單", "線上訂單"),
    order: build("Order", "訂單", "订单"),
    orderAmount: build("Order Amount", "訂單金額", "訂單金額"),
    orderCompleted: build("Order Completed", "訂單已完成", "訂單已完成"),
    orderDate: build("Order Date", "訂單日期", "订单日期"),
    createdBy: build("Created By", "創建者", "创建者"),
    orderDetails: build("Order Details", "訂單詳情", "订单详情"),
    orderHistory: build("Order History", "訂單歷史", "订单历史"),
    orderId: build("Order ID", "訂單編號", "訂單編號"),
    orderNotes: build("Order Notes", "訂單備註", "訂單備註"),
    orderNumber: build("Order Number", "訂單編號", "訂單編號"),
    orderStatus: build("Order Status", "訂單狀態", "订单状态"),
    orders: build("Orders", "訂單", "订单"),
    paid: build("Paid", "已付款", "已付款"),
    partPayment: build("Partial Payment", "部分付款", "部分付款"),
    partailPayment: build("Partial Payment", "部分付款", "部分付款"),
    partiallyPaid: build("Partially Paid", "部分付款", "部分付款"),
    payment: build("Payment", "付款", "付款"),
    paymentDate: build("Payment Date", "付款日期", "付款日期"),
    paymentInformation: build("Payment Information", "付款資料", "付款资料"),
    paymentMethod: build("Payment Method", "付款方式", "付款方式"),
    paymentStatus: build("Payment Status", "付款狀態", "付款状态"),
    paymentType: build("Payment Type", "付款方式", "付款方式"),
    pending: build("Pending", "待處理", "待处理"),
    pendingPickup: build("Pending Pickup", "待取貨", "待取货"),
    pendingToPickup: build("Pending to Pickup", "待取貨", "待取货"),
    pickedUp: build("Picked Up", "已取貨", "已取货"),
    pickupCompleted: build("Pickup Completed", "取貨完成", "取货完成"),
    pickupDate: build("Pickup Date", "取貨日期", "取貨日期"),
    pickupStatus: build("Pickup Status", "取貨狀態", "取货状态"),
    price: build("Price", "價格", "价格"),
    processing: build("Processing", "處理中", "处理中"),
    refund: build("Refund", "退款", "退款"),
    refundPayment: build("Refund Payment?", "退款付款？", "退款付款？"),
    remainingBalance: build("Remaining Balance", "剩餘金額", "剩余金额"),
    returned: build("Returned", "退貨", "退货"),
    saveNoDepositOrder: build("Save No Deposit Order", "保存零按金訂單", "保存零按金訂單"),
    searchOrderId: build("Search order ID or customer name", "搜尋訂單編號或客戶名稱", "搜索订单编号或客户名称"),
    searchProduct: build("Search product", "搜尋產品", "搜索产品"),
    showOrderSummary: build("Show summary", "顯示摘要", "显示摘要"),
    sendOrderEmail: build("Send Order Email", "電郵訂單", "電郵訂單"),
    shipFee: build("Shipping Fee", "運費", "运费"),
    shipped: build("Shipped", "已寄出", "已寄出"),
    status: build("Status", "狀態", "狀態"),
    subTotal: build("Sub Total", "小計", "小计"),
    success: build("Success", "成功", "成功"),
    total: build("Total", "總金額", "总金额"),
    totalCustomer: build("Total Customers", "總客戶數", "总客户数"),
    totalOrder: build("Total Orders", "總訂單量", "总订单量"),
    totalSales: build("Total Sales", "總銷售額", "總銷售額"),
    unpaid: build("Unpaid", "未付款", "未付款"),
    void: build("Void Order", "無效訂單", "作废订单"),
    voidOrderConfirm: build("Void this order?", "確定要作廢此訂單嗎？", "确定要作废此订单嗎？"),
    writeNote: build("Write Note", "輸入備註", "輸入備註"),
    combineOrder: build("combine", "結合", "结合"),
    combineOrderMessage: build(
      "You can combine your current cart with previous order to be eligible for free shipping. Previous shipping fee will be refunded to you as points.",
      "您可以將目前購物車與先前的訂單合併，即可享有免費送貨服務。之前的運費將以積分形式退還給您。",
      "您可以将当前购物车与之前的订单合并，即可享受免费送货服务。之前的运费将以积分形式退还给您。"
    ),
  },
  payment: {
    addPaymentOptions: build("Add Payment Options", "新增付款方式", "新增付款方式"),
    amountToPay: build("Amount To Pay", "應付金額", "應付金額"),
    awaiting: build("Awaiting", "未付款", "未付款"),
    deposit: build("Deposit", "訂金", "訂金"),
    fullPayment: build("Full Payment", "全額付款", "全額付款"),
    noPaymentDesc: build(
      "No payment options selected, go to the settings page to add payment options",
      "未選擇付款方式，請前往設定頁面添加付款方式",
      "未選擇付款方式，請前往設定頁面添加付款方式"
    ),
    paid: build("Paid", "已付款", "已付款"),
    partPayment: build("Partial Payment", "部分付款", "部分付款"),
    paymentOptions: build("Payment Options", "付款方式", "付款方式"),
    refunded: build("Refunded", "已退款", "已退款"),
    selectPaymentOption: build("Select Payment Option", "選擇付款方式", "選擇付款方式"),
    selectPaymentType: build("Select Payment Type", "選擇付款類型", "選擇付款類型"),
  },
  pos: {
    addNewCustomer: build("Add New Customer", "新增客戶", "新增客戶"),
    alipay: build("Alipay", "Alipay", "Alipay"),
    allCatgories: build("All Categories", "所有類別", "所有類別"),
    applePay: build("Apple Pay", "Apple Pay", "Apple Pay"),
    back: build("Back", "返回", "返回"),
    cash: build("Cash", "現金", "現金"),
    categories: build("Categories", "類別", "類別"),
    checkout: build("Checkout", "結賬", "結賬"),
    clickAProductToViewDetails: build("Click A Product To View Details", "點擊產品查看詳情", "點擊產品查看詳情"),
    clientInfo: build("Client Info", "客戶資料", "客戶資料"),
    contactInfo: build("Contact Info", "聯絡資料", "聯絡資料"),
    customer: build("Customer", "客戶", "客戶"),
    customerInfo: build("Customer Info", "客戶資料", "客戶資料"),
    discard: build("Discard", "放棄", "放棄"),
    eyesInfo: build("Eyes Info", "眼睛資料", "眼睛資料"),
    findCustomer: build("Find Customer", "搜尋客戶", "搜尋客戶"),
    fps: build("FPS", "FPS", "FPS"),
    googlePay: build("Google Pay", "Google Pay", "Google Pay"),
    guestCheckout: build("Guest Checkout", "訪客結帳", "訪客結帳"),
    hcv: build("Health Care Voucher", "醫療券", "医疗券"),
    holdCart: build("Hold Cart", "暂存購物車", "暫存購物車"),
    home: build("Home", "首頁", "主页"),
    item: build("Item", "產品", "产品"),
    items: build("Items", "產品", "產品"),
    cart: build("Cart", "購物車", "购物车"),
    recover: build("Recover", "恢復", "恢复"),
    showProducts: build("Show Products", "顯示產品", "显示产品"),
    lastPurchaseDate: build("Last Purchase Date", "最後購買日期", "最後購買日期"),
    loading: build("Loading...", "載入中", "載入中"),
    manualCashTransactions: build("Manual Cash Transactions", "手動現金交易", "手動現金交易"),
    masterCard: build("Master Card", "Master Card", "Master Card"),
    memberInfo: build("Member Info", "會員資料", "會員資料"),
    noTransactions: build("No Transactions", "無交易", "無交易"),
    numberInfo: build("Number Info", "數量資料", "數量資料"),
    octopus: build("Octopus", "Octopus", "Octopus"),
    orderInfo: build("Order Info", "訂單資料", "訂單資料"),
    orders: build("Orders", "訂單", "訂單"),
    pay: build("Pay", "付款", "付款"),
    payableAmount: build("Payable Amount", "應付金額", "應付金額"),
    payme: build("Payme", "Payme", "Payme"),
    paymentOptions: build("Payment Options", "付款選項", "付款選項"),
    paymentStatus: build("Payment Status", "付款狀態", "付款狀態"),
    paypal: build("Paypal", "Paypal", "Paypal"),
    placeAsOnlineOrder: build("Online Order", "網店訂單", "网店订单"),
    placeAsPosOrder: build("POS Order", "店舖訂單", "店舖订单"),
    posSytem: build("POS System", "POS 系統", "POS 系統"),
    print: build("Print", "列印", "列印"),
    printError: build("Printing Error!", "列印錯誤", "列印錯誤"),
    printReceipt: build("Print Receipt", "列印收據", "打印收据"),
    printing: build("Printing...", "列印中...", "列印中"),
    downloadPdf: build("PDF", "PDF", "PDF"),
    downloadingPdf: build("Downloading...", "下載中...", "下载中..."),
    pdfDownloadSuccess: build("Invoice PDF downloaded successfully", "發票PDF下載成功", "发票PDF下载成功"),
    pdfDownloadError: build("Failed to download PDF", "PDF下載失敗", "PDF下载失败"),
    pdfNotSupported: build("PDF invoice is not supported for this shop", "此商店不支援PDF發票", "此商店不支持PDF发票"),
    proceed: build("Proceed", "繼續", "繼續"),
    productDescription: build("Product Description", "產品說明", "產品說明"),
    restrictedMessage: build("You are restricted from accessing pos", "您無權訪問pos", "您無權訪問pos"),
    restrictedIpMessage: build(
      "Your IP address is not allowed to access POS",
      "您的IP地址不允許訪問POS",
      "您的IP地址不允许访问POS"
    ),
    restrictedTimeMessage: build("Access is restricted at this time", "此時段不允許訪問", "此时段不允许访问"),
    restrictedIpDetails: build("Your current IP address: {ip}", "您當前的IP地址：{ip}", "您当前的IP地址：{ip}"),
    restrictedHelpMessage: build(
      "Please contact your administrator if you believe this is an error",
      "如果您認為這是錯誤，請聯繫管理員",
      "如果您认为这是错误，请联系管理员"
    ),
    roundOffDeduct: build("Rounding Adjustment", "小數調整", "小数调整"),
    samsungPay: build("Samsung Pay", "Samsung Pay", "Samsung Pay"),
    save: build("Save", "儲存", "儲存"),
    scanMemberCode: build("Scan Member Code", "掃描會員碼", "掃描會員碼"),
    select: build("Select", "選擇", "選擇"),
    shortDescription: build("Short Description", "簡短說明", "簡短說明"),
    subTotal: build("Sub Total", "小計", "小计"),
    totalAmount: build("Total Amount", "總金額", "總金額"),
    totalSpendingAmount: build("Total Spending Amount:", "總消費金額", "總消費金額"),
    unionPay: build("Union Pay", "Union Pay", "Union Pay"),
    userChange: build("User Change", "找錢", "找零"),
    view: build("View", "檢視", "检视"),
    viewHeldCart: build("On-hold Order", "查看暫存購物車", "查看暫存購物車"),
    visa: build("Visa", "Visa", "Visa"),
    wechat: build("Wechat", "Wechat", "Wechat"),
    youAreAboutToDeleteEyeInfo: build(
      "You are about to delete this eye info record",
      "您即將刪除此眼睛資料記錄",
      "您即将删除此眼睛资料记录"
    ),
    deleteEyeInfo: build("Delete Eye Info", "刪除眼睛資料", "删除眼睛资料"),
    openRegister: build("Open Register", "開啟收銀機", "开启收银机"),
    viewHistory: build("History", "查看歷史", "查看历史"),
  },
  posMenuItems: {
    cash: build("Cash", "現金", "現金"),
    cashier: build("Cashbox", "收銀機", "收銀机"),
    customers: build("Customers", "客戶", "客戶"),
    deliveryPickup: build("Delivery Pickup", "送貨取貨", "送货取货"),
    deliveryPickupList: build("Delivery Pickup List", "送貨取貨列表", "送货取货列表"),
    history: build("History", "歷史", "歷史"),
    newOrder: build("New Order", "新訂單", "新訂單"),
    orderList: build("Order List", "訂單列表", "訂單列表"),
    orders: build("Orders", "訂單列表", "訂單列表"),
    products: build("Products", "產品", "產品"),
    recycle: build("Recycle", "回收", "回收"),
    scanProduct: build("Scan Product", "掃描產品", "掃描產品"),
    searchNoFound: build("No Results Found", "未找到結果", "未找到结果"),
    searchProducts: build("Search product", "搜索產品", "搜尋產品"),
    selectProduct: build("Select Prouduct", "選擇產品", "选择产品"),
    setting: build("Setting", "設定", "設定"),
    settlement: build("Settlement", "結算", "結算"),
    statistic: build("Statistic", "統計", "統計"),
    warehouse: build("Warehouse", "倉庫", "倉庫"),
    warehouseTransfer: build("Transfer", "倉庫調撥", "仓库调拨"),
  },
  posProducts: {
    addToCartSuccessfully: build("Successfully Added Item To Cart", "已成功將商品添加到購物車", "已成功將商品添加到購物車"),
    cartClearSuccessfully: build("Successfully Cleared Cart", "已成功清除購物車", "已成功清除購物車"),
    removeFromCartSuccessfully: build(
      "Successfully Removed Item From Cart",
      "已成功從購物車中刪除商品",
      "已成功從購物車中刪除商品"
    ),
  },
  product: {
    customProduct: build("Custom Product", "自訂產品", "自訂產品"),
    attachProductTo: build("Attach Product To", "附加產品至", "附加产品至"),
    add: build("Add Product", "新增產品", "新增产品"),
    addChild: build("Add Child Product", "新增子產品", "新增子产品"),
    addCustomOption: build("Add Option", "新增選項", "添加选项"),
    addMore: build("Add More", "新增", "新增"),
    availability: build("Availability", "庫存狀況", "库存状况"),
    createChildProduct: build("Create Variation Product (Child)", "更改多類 (子) 產品", "更改多类 (子) 產品"),
    customization: build("Customization", "客製化", "客製化"),
    description: build("Product Description", "產品說明", "产品说明"),
    descriptionGallery: build("Description Gallery", "描述圖庫", "描述图库"),
    details: build("Product Details", "產品詳情", "产品详情"),
    detailsFor: build("Details For", "詳細資訊", "详细信息"),
    edit: build("Edit Product", "更改產品", "更改产品"),
    editChild: build("Edit Child Product", "更改子產品", "更改子产品"),
    editChildProduct: build("Edit Variation Product (Child)", "更改多類 (子) 產品", "更改多类 (子) 產品"),
    featuredImage: build("Featured Image", "主要圖片", "主要图片"),
    generalInfo: build("General Info", "一般資料", "一般资料"),
    go: build("Go", "前往", "前往"),
    groupItem: build("Group Item", "群組項目", "群组项目"),
    image: build("Image", "圖片", "图片"),
    inStock: build("In Stock", "有貨", "有货"),
    isPromotionProduct: build("Promotion Product", "推廣產品", "推廣产品"),
    itemDesc: build("Item Description", "產品說明", "產品說明"),
    misc: build("MISC", "其他", "其他"),
    name: build("Product Name", "產品名稱", "产品名称"),
    noProductsFound: build("No Products Found", "未找到產品", "未找到产品"),
    outOfStock: build("Out of Stock", "缺貨", "缺货"),
    page: build("Page: ", "頁：", "頁："),
    price: build("Product Price", "產品價格", "产品价格"),
    price2: build("Price", "價格", "价格"),
    product: build("Product", "產品", "产品"),
    productGallery: build("Product Gallery", "產品圖庫", "产品图库"),
    productType: build("Product Type", "產品類型", "產品類型"),
    products: build("Products", "產品", "产品"),
    properties: build("Properties", "特性", "特性"),
    qty: build("Qty", "數量", "數量"),
    quantity: build("Quantity", "數量", "数量"),
    relatedProducts: build("Related Products", "相關產品", "相關產品"),
    searchProduct: build("Search Product", "搜尋產品", "搜尋產品"),
    shortDescription: build("Short Description", "簡短說明", "简短说明"),
    tag: build("Tag", "標籤", "标签"),
    simple: build("Simple Product", "簡易產品", "简易产品"),
    sku: build("SKU", "產品編號", "产品编号"),
    stockReadyDate: build("Stock Ready Date", "返貨日期", "返货日期"),
    topUps: build("Top Ups", "增值項目", "增值项目"),
    addTopUp: build("Add Top Up", "新增增值項目", "新增增值项目"),
    total: build("Total", "總金額", "總金額"),
    variationChild: build("Variation (Child)", "子產品", "子产品"),
    variationParent: build("Variation Product (Parent)", "多類產品 (母)", "多类产品 (母)"),
    variationProduct: build("Variation Product", "多類產品", "多类产品"),
    pleaseWait: build("Please wait, uploading file", "請稍候，正在上傳文件", "请稍候，正在上传文件"),
    uploadNew: build("Upload new image from this computer", "從這台電腦上傳新圖像", "从这台计算机上传新图像"),
    chooseRecent: build("Choose from media", "從圖片庫選擇", "从图片库选择"),
  },
  recycle: {
    recycle: build("Recycle", "回收", "回收"),
    recycleRecord: build("Recycles Record", "回收記錄", "回收记录"),
    recycles: build("Recycles", "回收", "回收"),
    totalPending: build("Total Pending", "总待处理", "總待處理"),
    totalRecycle: build("Total Recycles", "總回收量", "总回收量"),
  },
  setting: {
    chineseS: build("Simplified Chinese", "簡體中文", "簡體中文"),
    chineseT: build("Traditional Chinese", "繁體中文", "繁體中文"),
    chooseLanguage: build("Choose Language", "選擇語言", "選擇語言"),
    chooseShop: build("Choose Shop", "選擇商店", "選擇商店"),
    cny: build("CNY", "人民幣", "人民幣"),
    currencies: build("Currencies", "貨幣", "貨幣"),
    dateOfBirth: build("Date Of Birth", "出生日期", "出生日期"),
    defaultCurrency: build("Default Currency", "點認貨幣", "點認貨幣"),
    defaultLocale: build("Default Language", "默認語言", "默認語言"),
    email: build("Email Address", "電郵地址", "電郵地址"),
    english: build("English", "英文", "英文"),
    hkd: build("HKD", "港幣", "港幣"),
    image: build("Image", "圖片", "圖片"),
    joinedDate: build("Joined Date", "加入日期", "加入日期"),
    languages: build("Languages", "語言", "語言"),
    name: build("Name", "名稱", "名称"),
    orderCheckout: build("Order Checkout Summary", "訂單結帳摘要", "訂單結帳摘要"),
    posSetting: build("POS Setting", "POS 設定", "POS 設定"),
    posShopAddress: build("POS Shop Address", "POS 商店地址", "POS 商店地址"),
    posShopName: build("POS Shop Name", "POS 商店名稱", "POS 商店名称"),
    selectRetailShop: build("Select Retail Shop", "選擇零售店", "選擇零售店"),
    setting: build("Profile Setting", "個人設定", "個人設定"),
    usd: build("USD", "美金", "美金"),
    userRole: build("User Role", "用戶角色", "用戶角色"),
  },
  ship: {
    setDefault: build("Set as default", "設為默認", "設為默認"),
    recipientName: build("Receipent Name", "收件人姓名", "收件人姓名"),
    shippingCountry: build("Shipping Country / Region", "運送國家/地區", "運送國家/地區"),
    address: build("Address", "地址", "地址"),
    region: build("Region", "區域", "區域"),
    district: build("Area", "分區", "分區"),
    subDistrict: build("District", "地區", "地區"),
    location: build("Location", "位置", "位置"),
    tel: build("Tel", "電話號碼", "電話號碼"),
    state: build("State", "州", "州"),
    city: build("City", "巿", "巿"),
    zipCode: build("Zip Code", "郵區編號", "郵區編號"),
    submit: build("Add Address", "新增地址", "新增地址"),
    edit: build("Edit", "編輯", "編輯"),
    cancel: build("Cancel", "取消", "取消"),
    sf: build("S.F. Express", "順豐速運", "順豐速運"),
    sfLocation: build("SF Location", "順豐提取點", "順豐提取點"),
    pickSfLocation: build("Please Pick a Location", "選擇提取點", "選擇提取點"),
    sfPickUp: build("SF Pickup", "自取點", "自取點"),
    changeLocation: build("Change Location", "更改自取點", "更改自取點"),
    hideLocation: build("Hide List", "隱藏列表", "隱藏列表"),
    selectSfLocation: build("Choose S.F. Express Location", "選擇順豐速運地址", "選擇順豐速運地址"),
    previousAddressList: build("Previous Address List", "過往送貨地址", "過往送貨地址"),
    enterNewAddress: build("Enter New Address", "輸入新地址", "輸入新地址"),
    selectSfAddress: build("Select SF Lockers", "選擇順豐智能櫃", "選擇順豐智能櫃"),
    selectPickupAddress: build("Store Pickup", "門市自取", "門市自取"),
    select: build("Select", "選擇", "選擇"),
    sfAddress: build("Address", "地址", "地址"),
    sfCode: build("Code", "網點代碼", "網點代碼"),
    sfShippingMethod: build("Type", "類別", "類別"),
    sfOpening: build("Opening Hours", "營業時間", "營業時間"),
    sfMonToFri: build("Mon - Fri", "星期一至星期五", "星期一至星期五"),
    sfSatToSun: build("Sat - Sun", "星期六至星期日", "星期六至星期日"),
    sfBusinessStation: build("Business Station", "順豐營業點", "順豐營業點"),
    sfLocker: build("EF Locker", "順便智能櫃", "順便智能櫃"),
    sfServicePartner: build("Service Partner", "服務店舖", "服務店舖"),
    sfStore: build("Store", "順豐站", "順豐站"),
    sfSubDistrict: build("Sub District", "地區", "地區"),
    companyName: build("Company Name", "公司名稱", "公司名称"),
    companyAddress: build("Company Address", "公司地址", "公司地址"),
    companyNameO: build("Company Name (optional)", "公司名稱（可選)", "公司名称（可选)"),
    companyAddressO: build("Company Address (optional)", "公司地址（可選)", "公司地址（可选)"),
  },
  warehouseTransfer: {
    title: build("Warehouse transfer", "倉庫調撥", "仓库调拨"),
    outgoing: build("Outgoing", "發出", "发出"),
    incoming: build("Incoming", "收貨", "收货"),
    newTransfer: build("New transfer", "新增調撥", "新增调拨"),
    transferNumber: build("Transfer no.", "調撥編號", "调拨编号"),
    sectionDetails: build("Transfer details", "調撥資料", "调拨资料"),
    fromWarehouse: build("From warehouse", "來源倉庫", "来源仓库"),
    toStore: build("Destination store", "目的地店舖", "目的地店铺"),
    toWarehouse: build("Destination warehouse", "目的地倉庫", "目的地仓库"),
    lineItems: build("Line items", "貨品明細", "货品明细"),
    searchProducts: build("Find products", "搜尋產品", "搜寻产品"),
    parentProductNotForTransfer: build(
      "Parent / grouped products cannot be added. Search for a specific variant SKU.",
      "主款式／組合母項不能加入，請搜尋具體規格的子商品 SKU。",
      "主款式/组合母项不能加入，请搜寻具体规格的子商品 SKU。",
    ),
    noLineItems: build("Add at least one product", "請加入至少一項產品", "请加入至少一项产品"),
    saved: build("Saved", "已儲存", "已储存"),
    submitted: build("Submitted", "已提交", "已提交"),
    awaitingWarehousePrint: build(
      "Waiting for the warehouse admin to print and start picking.",
      "請等待總部倉庫於後台列印並開始執貨。",
      "请等待总部仓库于后台列印并开始拣货。"
    ),
    awaitingWarehouseDispatch: build(
      "Waiting for the warehouse admin to mark this transfer as on delivery.",
      "請等待總部倉庫於後台標記為運送中。",
      "请等待总部仓库于后台标记为运送中。"
    ),
    received: build("Stock-in completed", "已完成入庫", "已完成入库"),
    noTransfers: build("No transfer notes yet", "暫無調撥單", "暂无调拨单"),
    statusDraft: build("Draft", "草稿", "草稿"),
    statusSubmitted: build("Submitted", "已提交", "已提交"),
    statusPicking: build("Picking", "執貨中", "执货中"),
    statusOnDelivery: build("On delivery", "運送中", "运送中"),
    statusStockInCompleted: build("Completed", "已完成", "已完成"),
    shippedQty: build("Shipped qty", "出貨數量", "出货数量"),
    receivedQty: build("Received qty", "收貨數量", "收货数量"),
    completeReceive: build("Confirm receipt", "確認收貨", "确认收货"),
    errNotFound: build("Transfer note not found", "找不到調撥單", "找不到调拨单"),
    errNotEditable: build("This transfer can no longer be edited", "此調撥單已不可修改", "此调拨单已不可修改"),
    errSubmitFailed: build("Could not submit (check it is still a draft)", "無法提交（請確認仍為草稿）", "无法提交（请确认仍为草稿）"),
    errInsufficientStock: build("Insufficient stock at source warehouse", "來源倉庫庫存不足", "来源仓库库存不足"),
    errReceiveFailed: build("Could not receive (must be on delivery)", "無法收貨（須為運送中狀態）", "无法收货（须为运送中状态）"),
    errReceiveQtyMismatch: build("Received quantities must match shipped quantities", "收貨數量須與出貨數量一致", "收货数量须与出货数量一致"),
    errGeneric: build("Something went wrong", "發生錯誤", "发生错误"),
  },
  tag: {
    add: build("Add Tag", "添加标签", "编辑标签"),
    edit: build("Edit Tag", "新增標籤", "編輯標籤"),
  },
};

export type MessageType = typeof messages;

export default messages;
